import { render, staticRenderFns } from "./ControlBarDesktop.vue?vue&type=template&id=7195776e"
import script from "./ControlBarDesktop.vue?vue&type=script&lang=js"
export * from "./ControlBarDesktop.vue?vue&type=script&lang=js"
import style0 from "./ControlBarDesktop.vue?vue&type=style&index=0&id=7195776e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports